// extracted by mini-css-extract-plugin
export default {"SubjectButton":"subjectButton_SubjectButton__obK3U","icon":"subjectButton_icon__xDxce"};